import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import { FL_SIVEX_CODE, FL_SIVEX_ID, FL_STATUS, FL_UDN} from "../../../components/i18n/formLabels";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";
import SelectGeneric from "../../../components/select/selectGeneric";
import {udnProvider} from "../../../providers/udnProvider";
import {PH_SEARCH_SIVEX_CODE, PH_SEARCH_SIVEX_ID} from "../../../components/i18n/placeHolders";



const ProductFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app, userIsAdmin } = componentState?.data || {};

    const [status, setStatus] = useState(filter?.status || null);
    const [udnId, setUdnId] = useState(filter?.item?.udn?.id || null );
    const [onlyRegistered, setOnlyRegistered] = useState(true);



    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            sivexId: filter?.sivexId || '',
            sivexCode: filter?.sivexCode || '',
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            onlyRegistered: onlyRegistered,
            fbDataBase : { id : app?.fbDataBase?.id },
            item :  {
                ...data,
                udn : { id : udnId },
                status : status,
            }
        };

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setStatus(null);

        setOnlyRegistered(true);
        reset({
            code: ''
        });
    }

    return         <Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>{ FL_UDN }</Label>
                        <SelectGeneric
                            initialValue={ filter?.item?.udn?.id && udnId }
                            setExternalValue={  value => setUdnId( value ) }
                            provider = { udnProvider }
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_SIVEX_ID }</Label>
                        <Input type="text" name="sivexId"
                               placeholder={ PH_SEARCH_SIVEX_ID }
                               innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_SIVEX_CODE }</Label>
                        <Input type="text" name="sivexCode"
                               placeholder={ PH_SEARCH_SIVEX_CODE }
                               innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>{ FL_STATUS }</Label>
                        <br />
                        <Switch animate={true} offText={"No"} onText={"Si"}
                                value={status}
                                innerRef={register}
                                onChange={_ => setStatus(!status)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = _ => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(ProductFilters)